
import crudReducer from './crudReducer';

export default crudReducer('user');

